import { render, staticRenderFns } from "./ReviewBoosterListContainer.vue?vue&type=template&id=009ad68d&scoped=true&"
import script from "./ReviewBoosterListContainer.vue?vue&type=script&lang=js&"
export * from "./ReviewBoosterListContainer.vue?vue&type=script&lang=js&"
import style0 from "./ReviewBoosterListContainer.vue?vue&type=style&index=0&id=009ad68d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009ad68d",
  null
  
)

export default component.exports